// Tracks whether the backend is reachable, so the dashboard can say "we're updating"
// during a deploy instead of throwing unexplained errors at whoever is on the till.
//
// Mirrors the mobile app's BackendStatus: a gateway status (502/503/504) or a failed
// request means down, any real response means up again. Only responses from OUR API
// count — the update watcher polls nginx for a static file, and that staying up while
// the backend restarts is exactly the normal case.
const DOWN_STATUSES = new Set([502, 503, 504]);

let down = false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(down));

const setDown = (value) => {
    if (down === value) return;
    down = value;
    notify();
};

export const isBackendDown = () => down;

export const subscribeBackendStatus = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};

// A response came back from the API — 2xx/4xx both mean the server is answering.
export const reportBackendResponse = (status) => setDown(DOWN_STATUSES.has(status));

// The request never got a response: server restarting, connection refused, DNS, offline.
export const reportBackendUnreachable = () => setDown(true);

// fetch() wrapper for the screens that call it directly instead of going through axios
// (the POS till and sales list). Keeps their status reporting identical without having
// to rewrite them onto axios.
export const fetchWithStatus = async (input, init) => {
    try {
        const response = await fetch(input, init);
        reportBackendResponse(response.status);
        return response;
    } catch (error) {
        reportBackendUnreachable();
        throw error;
    }
};
